export default __webpack_public_path__ + "static/media/chrome-icon.5a3db800.svg";